package de.oevbs.kunde.kundenportal2.model.services.contact.types

import kotlinx.serialization.Serializable

@Serializable
enum class ComplaintReason(val text: String = "", val key: Int = -1) {
    DURATION("Bearbeitungsdauer",1),
    QUALITY_OF_CONSULTING("Beratungsqualität",2),
    INPUT_ERROR("Eingabefehler",3),
    REACHABILITY("Erreichbarkeit",4),
    FRIENDLINESS("Freundlichkeit",5),
    DISMISSAL("Kündigung",6),
    PRICING("Preisgestaltung",7),
    REGULATION("Regulierungsumfang",8),
    CORRESPONDENCE("Schriftwechsel",9),
    WEBSITE("Kundenportal/Internetseite",10)
}
